import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import logo from "../../../assets/GL-3d-logo2.png";
import Contact from "../../sections/Contact/Contact.js";
import "./FooterStyles.scss";

function Footer({ alwaysVisible }) {
	const { t } = useTranslation();
	const [isVisible, setIsVisible] = useState(Boolean(alwaysVisible));
	const [isMobile, setIsMobile] = useState(
		() => typeof window !== "undefined" && window.innerWidth <= 768
	);

	useEffect(() => {
		const handleResize = () => setIsMobile(window.innerWidth <= 768);
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	useEffect(() => {
		if (alwaysVisible || isMobile) {
			setIsVisible(true);
			return undefined;
		}

		const gallerySection = document.querySelector(".gallery");
		if (!gallerySection) {
			setIsVisible(true);
			return undefined;
		}

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) setIsVisible(true);
				});
			},
			{ root: null, rootMargin: "0px", threshold: 0 }
		);

		observer.observe(gallerySection);
		return () => observer.disconnect();
	}, [alwaysVisible, isMobile]);

	return (
		<section
			id="footer"
			className={`footer ${alwaysVisible || isVisible || isMobile ? "visible" : ""}`}
		>
			<div className="footer__container">
				<div className="footer__content">
					<div className="content-container">
						<div className="footer__logo">
							<img src={logo} alt="GLuck Esports" />
						</div>
						<div className="footer__next-text">
							<div>
								<h2 className="footer__copy">{t("footer.heading")}</h2>
								<p
									className="footer__copy-en en"
									dangerouslySetInnerHTML={{ __html: t("footer.text") }}
								/>
							</div>
							<div className="footer__next-area" data-add-line="">
								<a href="/calculate" className="footer__next-link en">
									{t("footer.button-heading")}
								</a>
								<a href="/calculate" className="link -end">
									<span className="link__text">
										<span className="en">{t("footer.button-text")}</span>
									</span>
									<span className="icon-button-arrow">
										<span>
											<i></i>
											<i></i>
										</span>
									</span>
								</a>
							</div>
						</div>
					</div>
				</div>
				<Contact />
			</div>
			<div className="footer__line-container">
				<div className="footer-line"></div>
				<div className="footer__legal-menu">
					<ul>
						<li>
							<Link to="/privacy">{t("footer.legal.privacy")}</Link>
						</li>
						<li>
							<Link to="/cookies">{t("footer.legal.cookies")}</Link>
						</li>
					</ul>
				</div>
				<p className="footer-line__text">{t("footer.copyright")}</p>
				<p className="footer-line__powered">
					powered by{" "}
					<a
						href="https://t.me/AnDy_MADEit"
						target="_blank"
						rel="noopener noreferrer"
					>
						@AnDy_MADEit
					</a>
				</p>
			</div>
		</section>
	);
}

export default Footer;
